// extracted by mini-css-extract-plugin
export default {"appStoreButton":"AppStoreButton_appStoreButton__MaYlS","appStoreButtonIcon":"AppStoreButton_appStoreButtonIcon__sD2Au"};